// extracted by mini-css-extract-plugin
export default {"root":"ShowMoreButton-root-24e45d531abed7fdbdd62d6b308084ee"};